import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Form } from 'components/layout'
import { PersonalBlock, AddressBlock } from 'components/sections/common'
import {
  AssessorOverview
} from 'components/sections/assessors'
import { FloatingBar, FormButton } from 'components/misc'
import { form, permissions } from 'helpers/decorators'
import { updateValidate } from 'models/contacts'
import { mapSchema } from 'models/assessors'
import AssessorsAffiliations
  from '../../../../components/sections/assessors/AssessorsAffiliations/AssessorAffiliations'
import { connect } from 'react-redux'
import { checkEmail } from '../../../../redux/modules/api/asyncValidations'
import { asyncValidate } from 'models/persons/asyncValidate'
import { apiConfiguration } from '../../../../helpers/decorators/api'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'


@permissions()
@apiConfiguration( {
  getValues: [CONFIGURATION_KEYS.enableLabels.id]
})
@connect(
    () => ({}),
    { checkEmail }
)
@form({
  form: 'assessorDetail',
  initialPropsMapper: props =>
    mapSchema(props),
  initialProps: 'assessors',
  validate: updateValidate,
  asyncValidate
})
class AssessorDetail extends Component {
  static propTypes = {
    codeLists: PropTypes.object.isRequired,
    common: PropTypes.object.isRequired,
    permissions: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    assessors: PropTypes.object.isRequired,
    change: PropTypes.func.isRequired,
    pristine: PropTypes.bool.isRequired,
    submitSucceeded: PropTypes.bool.isRequired,
    submitFailed: PropTypes.bool.isRequired,
    invalid: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    updateAssessor: PropTypes.func.isRequired,
    deleteAssessor: PropTypes.func.isRequired,
    changePersonState: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    values: PropTypes.object
  }

  static defaultProps = {
    assessors: {
      detail: {}
    }
  }

  render() {
    const {
      codeLists,
      common,
      change,
      pristine,
      submitSucceeded,
      submitFailed,
      invalid,
      submitting,
      handleSubmit,
      assessors,
      params,
      activeOrganization
    } = this.props

    const organizationId = params.organizationId || activeOrganization.id

    return (
      <Form
        className="form"
        loading={assessors.loading}
        onSubmit={handleSubmit(fields =>
          this.props.updateAssessor(
            organizationId,
            get(assessors, 'detail.id'),
            fields
          )
        )}
      >
        <div className="row">
          <div className="col-xs-6">
            <PersonalBlock
              titles={codeLists.titles.list}
              phoneTypes={codeLists.phoneTypes.list}
              change={change}
              data={assessors.detail}
              disableEmail
              personState={get(assessors, 'detail.person.personState')}
              migratedEmail={get(
                assessors,
                'detail.person.migratedContactEmail'
              )}
              canChangeEmail
              personId={get(assessors, 'detail.id')}
              personHocConfig={{ decoUpdateAssessor: true }}
              hasMiddleName={false}
              omitNote={false}
            />
          </div>
          <div className="col-xs-6">
            <AssessorOverview
              overviewData={get(assessors, 'overview.data')}
              assessorData={get(assessors, 'assessors.list')}
              modal={this.props.modal}
              deleteAssessor={this.props.deleteAssessor}
              changePersonState={this.props.changePersonState}
              orgContactDeletionTypes={
                codeLists.organizationContactReasonsOfDeletionTypes.list
              }
            />
            <AssessorsAffiliations
                data={assessors.detail}
                personId={get(this.props, 'params.assessorId')}
                organizationId={get(this.props, 'params.organizationId')}
                orgId={get(this.props, 'params.assessorId')}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <AddressBlock
              regions={common.regions.list}
              formPrefix="address"
              change={this.props.change}
              withCountry
            />
          </div>
        </div>
        <FloatingBar>
          <FormButton
            pristine={pristine}
            submitSucceeded={submitSucceeded}
            submitFailed={submitFailed}
            invalid={invalid}
            isLoading={submitting}
            type="submit"
            intlKey="button.save"
          >
            Save
          </FormButton>
        </FloatingBar>
      </Form>
    )
  }
}

export default AssessorDetail
